import { Component, OnInit } from "@angular/core";
import { UserService } from "app/auth/service";
import {
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-security",
  templateUrl: "./security.component.html",
  styleUrls: ["./security.component.scss"],
})
export class SecurityComponent implements OnInit {
  public passwordTextTypeNew: boolean = false;
  public passwordTextTypeRetype: boolean = false;

  public resetPasswordForm: FormGroup;

  public canResetPassword: boolean = false;

  public passwordMatch: boolean = true;
  public passwordValid: boolean = true;
  public passwordLongEnough: boolean = true;

  public lastConnections: Object[] = [];

  public browsersSrcs = {
    Chrome: 'assets/images/icons/google-chrome.png',
    Safari: 'assets/images/icons/apple-safari.png',
    Opera: 'assets/images/icons/opera.png',
    Firefox: 'assets/images/icons/mozila-firefox.png',
    IExplorer: 'assets/images/icons/internet-explorer.png',
  }

  constructor(
    private _formBuilder: FormBuilder,
    private _userService: UserService
  ) {}

  get newPasswordInputs() {
    return this.resetPasswordForm.controls;
  }

  public togglePasswordTextTypeNew(): void {
    this.passwordTextTypeNew = !this.passwordTextTypeNew;
  }

  public togglePasswordTextTypeRetype(): void {
    this.passwordTextTypeRetype = !this.passwordTextTypeRetype;
  }

  updatePassword() {
    this.passwordMatch = true;
    this.passwordValid = true;
    this.passwordLongEnough = true;
    this._userService
      .editUserPassword({
        password: this.resetPasswordForm.value.newPassword,
        password_confirmation: this.resetPasswordForm.value.confirmPassword,
      })
      .subscribe(
        (data) => {
          console.log(data);
        },
        (error) => {
          console.log({ error });
          switch (error) {
            case "validation.confirmed":
              this.passwordMatch = false;
              break;
            case "validation.required":
              this.passwordValid = false;
              break;
            case "validation.min.string":
              this.passwordLongEnough = false;
            default:
              this.passwordValid = false;
              break;
          }
        }
      );
  }

  checkResetPasswordConditions() {
    if (
      !this.resetPasswordForm.value.newPassword &&
      !this.resetPasswordForm.value.confirmPassword
    )
      this.canResetPassword = false;
    else if (
      this.resetPasswordForm.value.newPassword !==
      this.resetPasswordForm.value.confirmPassword
    )
      this.canResetPassword = false;
    else this.canResetPassword = true;
  }

  ngOnInit(): void {
    this.resetPasswordForm = this._formBuilder.group({
      newPassword: ["", [Validators.required]],
      confirmPassword: ["", [Validators.required]],
    });

    this._userService.getAccountLastConnections().subscribe(
      (data) => {
        this.lastConnections = data;
      },
      (error) => {
        console.log({ error });
      }
    );
  }
}
